export default new class ScrollTopArrow {
    constructor() {
        this.scrollTopArrow = '[data-scroll-top-arrow]';

        if (!$(this.scrollTopArrow).length) return;

        this.conf = {
            arrowShowOffset: 100,
            scrollTopSpeed: 700
        };

        this.$arrow = $(this.scrollTopArrow);
        this.classShow = '_show';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.scrollTopArrow, () => {
            this.scrollTop();
        });

        $doc.on('scroll', (e) => {
            this.toggleScrollTopArrow($(e.currentTarget))
        })
    }

    scrollTop() {
        $('html, body').animate({
            scrollTop: 0
        }, this.conf.scrollTopSpeed)
    }

    toggleScrollTopArrow($document) {
        if ($document.scrollTop() > this.conf.arrowShowOffset) {
            if (this.$arrow.hasClass(this.classShow)) return;
            this.$arrow.addClass(this.classShow);
        } else {
            this.$arrow.removeClass(this.classShow);
        }
    }
}
